<iframe id="scaled-frame" src="https://programy.p.lodz.pl/ectslabel-web/" height="1000rem" width="100%"></iframe>

<h3>Unfortunetely, this is a project on it's own...</h3>